export default (...args) => {
  args.pop();
  const sep = args.shift();
  const str = args.shift();

  if (!sep || !str) {
    return '';
  }

  return str.split(sep);
};